import { ReaderStatus, type Device, type PaymentReader } from "@/types";

type ReaderProvider = Pick<PaymentReader, "provider">;

export function isMockReader(reader: ReaderProvider): boolean {
  return reader.provider.toUpperCase() === "MOCK";
}

export function isSumupReader(reader: ReaderProvider): boolean {
  return reader.provider.toUpperCase() === "SUMUP";
}

/** SumUp reader paired with the Cloud API: the only kind with a live device status. */
export function isPairedSumupReader(
  reader: Pick<PaymentReader, "provider" | "status">,
): boolean {
  return isSumupReader(reader) && reader.status === ReaderStatus.PAIRED;
}

/**
 * A reader that can be linked to `device`: any mock reader, or a paired SumUp
 * reader in the device's region (any region when the device has none).
 */
export function isLinkableReader(
  reader: Pick<PaymentReader, "provider" | "status" | "region_id">,
  device: Pick<Device, "region_id">,
): boolean {
  if (isMockReader(reader)) {
    return true;
  }
  if (!isPairedSumupReader(reader)) {
    return false;
  }
  return !device.region_id || reader.region_id === device.region_id;
}
